var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCloudProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 71,
    viewBox: "0 0 75 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6153 55.9166V44.25H49.9611L37.5001 29.6666L25.0391 44.25H34.3848V55.9166H40.6153Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9237 55.9167H28.1542V50.0834H21.9237C16.7711 50.0834 12.5779 46.1575 12.5779 41.3334C12.5779 37.2384 16.3131 33.295 20.905 32.5396L22.715 32.2421L23.3131 30.6146C25.5031 24.6325 30.9423 20.9167 37.5 20.9167C46.0887 20.9167 53.0762 27.4588 53.0762 35.5V38.4167H56.1915C59.6276 38.4167 62.422 41.033 62.422 44.25C62.422 47.4671 59.6276 50.0834 56.1915 50.0834H46.8457V55.9167H56.1915C63.0637 55.9167 68.6525 50.6842 68.6525 44.25C68.6477 41.6356 67.7074 39.098 65.9818 37.0425C64.2561 34.9869 61.8446 33.532 59.1323 32.91C57.7709 22.8709 48.5903 15.0834 37.5 15.0834C28.9143 15.0834 21.4564 19.7821 18.0514 27.1875C11.3599 29.06 6.34741 34.975 6.34741 41.3334C6.34741 49.3746 13.3349 55.9167 21.9237 55.9167Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCloudProduct);
export default __webpack_public_path__ + "static/media/icons-cloud-product.6bf122d1031c4f72b0b232b9e046702c.svg";
export { ForwardRef as ReactComponent };